export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/comic_cartoon.216381b.png";